import { useState } from "react";
import { ProviderContext, withSnackbar } from "notistack";
import FirebaseService from "../../services/firebase/FirebaseService";
import StandardModal from "./StandardModal";
import ModalSize from "./ModalSize";
import LoadingButton from "../Loading/LoadingButton";

// Delete class modal

interface DeleteClassProps {
  classId: string;
  className: string;
  open: boolean;
  cancelClose: () => void;
}

const DeleteClassModal = (props: DeleteClassProps & ProviderContext) => {
  // Local loading button state and functionality to be passed to Standard Modal
  const [loadingButtonState, setLoadingButtonState] = useState(LoadingButton.BeforeLoading);

  const deleteClass = () => {
    FirebaseService.deleteClass(props.classId)
      .then(() => {
        props.cancelClose();
        props.enqueueSnackbar("Class deleted.", {
          variant: "success",
          autoHideDuration: 5000,
        });
      })
      .catch(() => {
        props.enqueueSnackbar("Could not delete.", {
          variant: "error",
          autoHideDuration: 5000,
        });
      });
    setLoadingButtonState(LoadingButton.BeforeLoading);
  };

  return (
    <StandardModal
      cancelClose={props.cancelClose}
      onSubmit={deleteClass}
      changeLoadingButtonState={setLoadingButtonState}
      loadingButtonState={loadingButtonState}
      title={`Delete ${props.className}?`}
      open={props.open}
      size={ModalSize.extraSmall}
      onlyOneButton={false}
    >
      This cannot be undone.
    </StandardModal>
  );
};

export default withSnackbar(DeleteClassModal);
